import { Component, OnInit, ViewChild } from '@angular/core';
import { Tarea, TareaTipo } from '../../../../interfaces/tarea';
import { ActivatedRoute } from '@angular/router';
import { TareaService } from '../../../../providers/tarea.service';
import { Cotizacion } from '../../../../interfaces/cotizacion';
import * as moment from 'moment';
import { ListarTareaResponsablesComponent } from '../../../../forms/tareas/tarea-responsables/listar-tarea-responsables/listar-tarea-responsables.component';
import { Usuario } from '../../../../interfaces/usuario';
import { TareaResponsable } from '../../../../forms/tareas/tarea-responsables/tarea-responsable/tarea-responsable';
import { Entidad } from '../../../../interfaces/entidad';

@Component({
  selector: 'app-detalle-tarea-pagina',
  templateUrl: './detalle-tarea-pagina.component.html',
  styleUrls: ['./detalle-tarea-pagina.component.scss']
})
export class DetalleTareaPaginaComponent implements OnInit {
  cargando: boolean = true;
  IdTarea?: number | string;
  tarea: Tarea;

  @ViewChild('listadoTareaResponsables') listadoTareaResponsables: ListarTareaResponsablesComponent;

  constructor(
    private route: ActivatedRoute,
    private tareaService: TareaService
  ) { }

  ngOnInit() {
    this.tarea = new Tarea();

    this.route.params.subscribe(params => {
      this.IdTarea = params['id'];
      this.actualizarDetalle();
    });
  }

  actualizarResponsables(): void { // actualizar archivos
    if (this.listadoTareaResponsables) {
      this.listadoTareaResponsables.IdTarea = this.IdTarea;
      this.listadoTareaResponsables.actualizarTabla();
    }
  }

  actualizarDetalle(): void {
    this.cargando = true;
    this.tareaService.getTareas(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        IdTarea: this.IdTarea
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.tareas) {
          var tarea = respuesta.data.tareas[0];
          if (tarea) {
            this.tarea = new Tarea(
              tarea.IdTarea,
              tarea.titulo,
              tarea.fechaTarea,
              tarea.fechaTarea ? moment(tarea.fechaTarea).format('HH:mm:ss') : null,
              tarea.fechaNotificacion,
              tarea.fechaNotificacion ? moment(tarea.fechaNotificacion).format('HH:mm:ss') : null,
              tarea.descripcion,
              tarea.cantidadResponsables,
              tarea.totalCompletadasResponsables,
              new Cotizacion(
                tarea.cotizacion.IdCotizacion,
                null,
                new Entidad(
                  tarea.cotizacion.entidad.id,
                  tarea.cotizacion.entidad.razonSocial
                ),
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                tarea.cotizacion.numero,
                tarea.cotizacion.fechaHoraModificacion,
                null,
                null,
                null
              ),
              new TareaTipo(
                tarea.tipo.id,
                tarea.tipo.descripcion
              ),
              (tarea.soyResponsable) ? new TareaResponsable(
                tarea.soyResponsable.IdTareaResponsable,
                new Usuario(
                  tarea.soyResponsable.usuario.IdUsuario,
                  tarea.soyResponsable.usuario.usuario,
                  null,
                  null,
                  null,
                  tarea.soyResponsable.usuario.nombre,
                  tarea.soyResponsable.usuario.apellido
                ),
                tarea.soyResponsable.fechaCompletada
              ) : null
            );

            this.actualizarResponsables();
          }
        }
      },
      () => {
        this.cargando = false;
      },
      () => {
        this.cargando = false;
      }
    );
  }
}
